import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../../services/storage.service';
import { NavigationService } from '../../../services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-payment-modal',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './payment-modal.component.html',
    styleUrl: './payment-modal.component.scss',
})
export class PaymentModalComponent {
    constructor(
        private activeModale: NgbActiveModal,
        private navigationService: NavigationService
    ) {}

    goToPayment() {
        this.activeModale.close('pay');
        this.navigationService.goToOffers();
    }

    goToHome() {
        this.activeModale.close('cancel');
    }
}
